module.exports = __webpack_public_path__ + "madeira.svg?c2491a33035cac9d36fe61bf90b727c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/madeira.svg
// module id = 220
// module chunks = 10